import React from 'react';
import styled from 'styled-components';

export const RepeatingElementsWrapper = styled.div`
    svg {
      animation-name: lavaLamp;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-duration: 180s;
      animation-play-state: running;
      @keyframes lavaLamp {
          0% {transform: rotate(0deg)}
          100% {transform: rotate(360deg)}
      }
    }
`;



// WEBPACK FOOTER //
// ./src/components/RepeatingElements/styled-components.js